import { DataAnalyticsTaggingEvent, DataAnalyticsTaggingEvents, DataAnalyticsTaggingEventType } from '../../features/data-analytics-tagging/data-analytics-tagging.domain';
import { W8BenModalName } from './w8ben-form.domain';

export class W8benFormAnalytics {
  static modalRouterTaggingEvents: DataAnalyticsTaggingEvents = {
    modalW8benPreview: {
      ...W8benFormAnalytics.getModalEvent(W8BenModalName.UPDATE, undefined, 'start')
    },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    modalW8benTax_residency_benefits: {
      ...W8benFormAnalytics.getModalEvent(W8BenModalName.TAX_RESIDENCY)
    },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    modalW8benUs_Tin: {
      ...W8benFormAnalytics.getModalEvent(W8BenModalName.US_TIN, 'a')
    }
  };

  static taggingEvents: DataAnalyticsTaggingEvents = {
    ...this.modalRouterTaggingEvents
  };

  static getModalEvent(modalName: W8BenModalName, flow?: string, step?: string): DataAnalyticsTaggingEvent {
    const modalRegisterEvent: DataAnalyticsTaggingEvent = {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        modalName: `W8Ben-${modalName}`,
        subSection1: 'home',
        subSection2: 'summary',
        flowType: flow ? `flow ${flow}` : 'n/a',
        customPageName: `wb_modal-W8Ben-${modalName}`
      },
      process: {
        processName: 'tdw:wbt:w8ben'
      }
    };
    if (step && modalRegisterEvent.process) {
      modalRegisterEvent.process.processType = `tdw:wbt:w8ben:${step}`;
    }
    return modalRegisterEvent;
  }
}
